import {
  ISoccerMatchMissedPenaltyEvent,
  ISoccerMatchMissedPenaltyEventWithCount,
} from "../../../../types";

type MissedPenaltyEventIconProps = {
  event:
    | ISoccerMatchMissedPenaltyEvent
    | ISoccerMatchMissedPenaltyEventWithCount;
  iconSize?: number;
  showTime?: boolean;
  showCount?: boolean;
  wrapperClassName?: string;
  timeClassName?: string;
  countClassName?: string;
};

export function GlobalMissedPenaltyEvent({
  event,
  iconSize = 16,
  showTime = false,
  showCount = false,
  wrapperClassName = "",
  timeClassName = "",
  countClassName = "event-count",
}: MissedPenaltyEventIconProps) {
  const goalImgSrc = "/images/match-events/missed-penalty-bg.svg";

  return (
    <div className={wrapperClassName}>
      {showCount && "count" in event && event.count > 1 && (
        <span className={countClassName}>{event.count}</span>
      )}
      <img
        src={goalImgSrc}
        height={iconSize}
        width={iconSize}
        alt="missed penalty"
        className="goal-event"
      />
      {showTime && (
        <span className={timeClassName}>{`${event?.timeMin}'`}</span>
      )}
    </div>
  );
}
